<div class="w-100 p-3" *ngIf="!templateService.addingTemplate">
    <div>
        <div class="row my-3">
            <div class="col-6">
                <h3>Attributi Oggetto</h3>
            </div>
            <div class="col-2 m-auto">
                <button *ngIf="deletable"
                        class="btn btn-outline-danger rounded-lg border-0"
                        ngbTooltip="Elimina"
                        (click)="onDeleteFeature()">
                    <fa-icon [icon]="icons.faTrash"></fa-icon>
                </button>
            </div>
            <div class="col-4 modifica-switch">
                <div class="custom-control custom-switch modifica-switch-control" *ngIf="editable">
                    <input type="checkbox" [checked]="editing" class="custom-control-input" id="modificareSwitch"
                        (click)="toggleEditing()" [disabled]="!collection?.actions.includes('edit')">
                    <label class="custom-control-label" for="modificareSwitch">Modifica</label>
                </div>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-6">
                <h5>{{collectionName}}</h5>
            </div>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table detail-box">
            <tbody>
                <tr *ngFor="let field of fieldList">
                    <th scope="row" *ngIf="!editing">
                        {{field.external_name}}
                    </th>

                    <th scope="row" *ngIf="editing">
                        {{field.external_name}} <span *ngIf="field.mandatory" ngbTooltip="Required">*</span>
                    </th>

                    

                    <!-- Editing -->
                    <!-- 4 types considered as stated in documentation (string, number, date, enumerator) -->
                    <td *ngIf="editing">
                        <div *ngIf="field.type == 'enumerator'">
                            <span *ngIf="field.readonly">{{ objectData[field.name] }}</span>
                            <select *ngIf="!field.readonly" class="custom-select" [id]="field.name"
                                [(ngModel)]="formFields[field.name].model">
                                <option *ngFor="let selectElement of enumerators[field.enumerator]"
                                    [value]="selectElement">{{selectElement}}</option>
                            </select>
                        </div>

                        <div *ngIf="field.type == 'string'">
                            <span *ngIf="field.readonly">{{ objectData[field.name] }}</span>
                            <input *ngIf="!field.readonly" type="text" [(ngModel)]="formFields[field.name].model"
                                class="form-control" [id]="field.name" [placeholder]="field.external_name">
                        </div>

                        <div *ngIf="field.type == 'number'">
                            <span *ngIf="field.readonly">{{ objectData[field.name] }}</span>
                            <input *ngIf="!field.readonly" type="number" [(ngModel)]="formFields[field.name].model"
                                class="form-control" [id]="field.name" [placeholder]="field.external_name">
                        </div>

                        <div *ngIf="field.type == 'date'">
                            <span *ngIf="field.readonly">{{ objectData[field.name] }}</span>
                            <input *ngIf="!field.readonly" type="date" [(ngModel)]="formFields[field.name].model"
                                class="form-control" [id]="field.name" [placeholder]="field.external_name">
                        </div>

                        <div
                            *ngIf="field.type != 'enumerator' && field.type != 'string' && field.type != 'date' && field.type != 'number'">
                            <span>{{ objectData[field.name] }}</span>
                        </div>


                    </td>
                    <td *ngIf="!editing">
                        <span>{{ objectData[field.name] }}</span>
                    </td>

                    <!-- Editing -->
                </tr>
            </tbody>
        </table>
    </div>
    <button *ngIf="editing" class="btn btn-salva btn-block" (click)="salvaObjectDetails()">Salva</button>
</div>

<app-template-details *ngIf="templateService.addingTemplate"></app-template-details>